Selector.View.QuestionTabListView = Backbone.View.extend(
/** @lends Selector.View.QuestionListView# */
{
	initialize: function() {

    	_.bindAll(this, "render");
        this.collection.on('reset',this.render);
        this.collection.on('change',this.render);
        
	},
	
	/** Render function */
	render: function() {

        //allows app to be loaded on page without the DOM element being present
        this.setElement($(".e_selector_tabs"));

        var fragment = document.createDocumentFragment();
        //just show 1 question per tab
        this.collection.each(function (model) {
            var modelView = new Selector.View.QuestionTabView({model: model});
            fragment.appendChild(modelView.render().el);
        }, this);

		this.$el.html(fragment);

        $('.tooltip').tooltip({
            hide: 50,
            show: 50,
            position: { my: "center top",  at: "center bottom"},
            content: function(){return $(this).data("tooltip");}
        });

		return this;
	}

});